import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PUBLIC_API = `${BACKEND_URL}/api`;

const publicApi = axios.create({ baseURL: PUBLIC_API });

export default publicApi;

// Convert a relative /api/media path or absolute url to a fully qualified URL.
export function resolveMediaUrl(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
}

const MONTH_ABBR = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

// Map a category color slug to one of the brand badge styles used by the homepage cards.
const VALID_BADGE_COLORS = new Set(['coral', 'teal', 'yellow']);

export function badgeFromCategory(cat) {
  const color = cat?.color;
  if (color && VALID_BADGE_COLORS.has(color)) return color;
  return 'coral';
}

// Format start/end times into the "6:00 PM - 9:00 PM" string used by cards.
function formatTime12h(t) {
  if (!t) return '';
  const [h, m] = t.split(':').map((x) => parseInt(x, 10));
  if (Number.isNaN(h)) return t;
  const hr = h % 12 || 12;
  const ampm = h < 12 ? 'AM' : 'PM';
  const min = !Number.isNaN(m) ? String(m).padStart(2, '0') : '00';
  return `${hr}:${min} ${ampm}`;
}

export function formatTimeRange(start, end) {
  const s = formatTime12h(start);
  const e = formatTime12h(end);
  if (s && e) return `${s} - ${e}`;
  return s || e || '';
}

// Parse a YYYY-MM-DD start_date into { day, month } strings for the event card badge.
export function dayMonthFromDate(dateStr) {
  if (!dateStr) return { day: '--', month: '' };
  const parts = dateStr.split('-');
  if (parts.length !== 3) return { day: '--', month: '' };
  const [, mm, dd] = parts;
  const monthIdx = parseInt(mm, 10) - 1;
  return {
    day: String(parseInt(dd, 10)),
    month: MONTH_ABBR[monthIdx] || '',
  };
}

// Normalize an API event into the shape consumed by the public Events card.
export function normalizeEventForCard(ev) {
  const { day, month } = dayMonthFromDate(ev.start_date);
  return {
    id: ev.id,
    day,
    month,
    time: formatTimeRange(ev.start_time, ev.end_time) || (ev.cost || ''),
    title: ev.title,
    desc: ev.short_description || ev.description || '',
    image: resolveMediaUrl(ev.featured_image) || 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=700&h=500&fit=crop',
    badge: badgeFromCategory(ev.category),
    location: ev.location || '',
    registerUrl: ev.register_url || '',
    isFeatured: !!ev.is_featured,
    category: ev.category || null,
    rawStartDate: ev.start_date,
    rawStartTime: ev.start_time || '',
    rawEndTime: ev.end_time || '',
  };
}
